import { useMutation, useQueryClient } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebUrls } from "../../../../ne-web-urls";
import type { PPAInvoiceId } from "../PPAInvoicePage.types";
import { ppaDeliveryInvoicesQueryOptions } from "./usePPADirectDeliveryInvoices";

export function useSendInvoice() {
  const queryClient = useQueryClient();

  const sendInvoiceMutation = useMutation({
    mutationFn: (ppaInvoiceId: PPAInvoiceId) => sendInvoice(ppaInvoiceId),
    onSuccess: handleSuccess
  });

  async function handleSuccess() {
    await queryClient.invalidateQueries({
      queryKey: ppaDeliveryInvoicesQueryOptions.queryKey
    });
  }

  return { sendInvoiceMutation };
}

async function sendInvoice(ppaInvoiceId: PPAInvoiceId) {
  return neWebApi.post(neWebUrls.api.ppaSendInvoice(), {
    unique_identifier: ppaInvoiceId
  });
}
